import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { ffDialogTc, ffDialogTitle, rowspancell, styles } from './muiStyles';
import { rows } from './EditFlatFileRowFormatSpecifier';

const FormatSpecifiersDialog = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  const classes = styles;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { minHeight: '90%', maxWidth: 'fit-content' } }}
      sx={classes.dialogTitle}
    >
      <DialogTitle sx={ffDialogTitle}>
        <div>
          <b>Format Specifiers</b>
        </div>
        <CloseOutlined onClick={onClose} style={{ marginRight: '0px', marginLeft: 'auto' }} />
      </DialogTitle>
      <DialogContent sx={{ maxWidth: 'fit-content', padding: '10px' }}>
        <Table stickyHeader sx={classes.dialogTable}>
          <TableHead>
            <TableRow>
              <TableCell style={ffDialogTc}>Date Part</TableCell>
              <TableCell style={ffDialogTc}>Specifier</TableCell>
              <TableCell style={ffDialogTc}>Description</TableCell>
              <TableCell style={ffDialogTc}>Example</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) =>
              row.data.map((dataRow, dataIdx) => (
                <TableRow key={`${idx}-${dataIdx}`}>
                  {dataIdx === 0 && (
                    <TableCell rowSpan={row.data.length} sx={rowspancell}>
                      {row.section}
                    </TableCell>
                  )}
                  <TableCell>{dataRow[0]}</TableCell>
                  <TableCell>{dataRow[1]}</TableCell>
                  <TableCell>{dataRow[2]}</TableCell>
                </TableRow>
              )),
            )}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};

export default FormatSpecifiersDialog;
